import React from "react";
import { ArrowUpRight } from "lucide-react";
import { creditResources } from "../../mock";

export default function CreditResources() {
  return (
    <section id="credit-resources" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-gold font-semibold tracking-[0.2em] uppercase text-sm">
            Tools &amp; Partners
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-navy mt-3">
            Credit Resources
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Trusted partner programs to help you protect, build and restore your
            credit and capital.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {creditResources.map((r) => (
            <article
              key={r.id}
              className="group rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={r.image}
                  alt={r.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-serif text-xl font-semibold text-navy leading-snug">
                  {r.title}
                </h3>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed flex-1">
                  {r.description}
                </p>
                <a
                  href={r.link}
                  target={r.link && r.link.startsWith("http") ? "_blank" : undefined}
                  rel={r.link && r.link.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="mt-5 inline-flex items-center gap-1.5 text-gold-dark font-semibold text-sm hover:gap-2.5 transition-all"
                >
                  {r.cta}
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
